// Generate notification sounds using Web Audio API

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext {
	if (!audioContext) {
		audioContext = new AudioContext();
	}
	return audioContext;
}

/**
 * Play a warm, bell-like tone
 * @param frequency Base frequency in Hz (higher = brighter)
 * @param duration Duration in seconds
 */
function playTone(frequency: number, duration: number = 0.3) {
	const ctx = getAudioContext();
	const now = ctx.currentTime;

	// Oscillator for the tone
	const osc = ctx.createOscillator();
	osc.type = 'sine';
	osc.frequency.setValueAtTime(frequency, now);

	// Gain for volume envelope (fade out)
	const gain = ctx.createGain();
	gain.gain.setValueAtTime(0.3, now);
	gain.gain.exponentialRampToValueAtTime(0.01, now + duration);

	// Connect: oscillator -> gain -> output
	osc.connect(gain);
	gain.connect(ctx.destination);

	// Play
	osc.start(now);
	osc.stop(now + duration);
}

/**
 * Play a two-tone chime (rising interval)
 */
function playChime() {
	// First tone (lower)
	playTone(523.25, 0.15); // C5

	// Second tone (higher) - slight delay
	setTimeout(() => {
		playTone(659.25, 0.2); // E5
	}, 100);
}

/**
 * Play notification sound based on event type
 */
export function playNotificationSound(type: 'focus' | 'break' | 'movement') {
	try {
		switch (type) {
			case 'focus':
				// Higher, energizing - back to work
				playTone(880, 0.25); // A5
				break;
			case 'break':
				// Lower, softer - exhale
				playTone(440, 0.35); // A4
				break;
			case 'movement':
				// Two-tone chime - get up and move
				playChime();
				break;
		}
	} catch (e) {
		console.error('Failed to play sound:', e);
	}
}
